import theme from "styles/theme";
import * as S from "./styles";

export type Props = {
  children: JSX.Element | JSX.Element[];
  border: boolean;
  backgroundColor: string;
  borderRadius?: number;
  borderColor?: string;
};
function Card({
  children,
  border,
  backgroundColor,
  borderRadius,
  borderColor = theme.colors.neutral[100],
  ...props
}: Props): JSX.Element {
  return (
    <S.Container
      backgroundColor={backgroundColor}
      border={border}
      borderRadius={borderRadius}
      borderColor={borderColor}
      {...props}
    >
      {children}
    </S.Container>
  );
}

export default Card;
